import React, { useState } from 'react'
import { Panel, Row, Col } from 'rsuite'
export default function ViewFormListWidget({ objects, prefix, fixedResultType, ...props }) {
  const emptyValue = <>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</>

  const displayCompt = (data, tabRight) => {
    // console.log('data : ', data)
    return (
      <>
        {data?.map((item, index) => {
          let inputObj

          //<ControlLabel>{item.section1}</ControlLabel>

          if (item.inputType == 'radio') {
            inputObj = (
              <>
                {item.section1} {item.valueDesc ? item.valueDesc : <u> {emptyValue}</u>}
                <>
                  {item?.moreInputs?.map((e) => {
                    return (
                      <>
                        {item.isBolder ? <strong>{item.section1}</strong> : item.section1}{' '}
                        <u>{item.result || emptyValue}</u>
                        {item.unit || ''}
                      </>
                    )
                  })}
                </>
              </>
            )
          } else {
            inputObj = (
              <>
                {prefix ? prefix + ' ' : ''}
                {item.section1}
                {item.resultType != '' && item.resultType != '0' && (
                  <span style={{ marginLeft: 5, marginRight: 5 }}>
                    <b>
                      <u>
                        {' '}
                        {item.result ||
                          (item.resultType == '1' && fixedResultType != 1 ? emptyValue : '')}{' '}
                      </u>
                    </b>{' '}
                    {item.unit || ''}
                  </span>
                )}

                {item?.moreInputs?.map((e) => {
                  return (
                    <>
                      {e.isBolder ? <strong>{e.section1}</strong> : e.section1}{' '}
                      {e.resultType != '' && e.resultType != '0' && (
                        <span style={{ marginLeft: 5, marginRight: 5 }}>
                          <b>
                            <u>
                              {' '}
                              {e.result ||
                                (e.resultType == '1' && fixedResultType != 1
                                  ? emptyValue
                                  : '')}{' '}
                            </u>
                          </b>{' '}
                          {e.unit || ''}
                        </span>
                      )}
                    </>
                  )
                })}

                {item.childs && displayCompt(item.childs, true, index)}
              </>
            )
          }

          return (
            <Row style={{ marginLeft: tabRight ? 20 : undefined, marginTop: 10 }}>
              <Col xs={24} sm={24} md={24} lg={24}>
                {/* {index + 1}. */}
                {inputObj}
              </Col>
            </Row>
          )
        })}
      </>
    )
  }

  return <Panel style={props.style}>{displayCompt(objects, false, 0)}</Panel>
}
